import React, { Component } from 'react';

const BUSINESS_UNIT_ID = '653f8fcfe9710b8d04037792';
const REVIEW_URL = 'https://uk.trustpilot.com/review/game.city';

// Trustpilot widget template IDs
export const TRUSTPILOT_TEMPLATES = {
    CAROUSEL: '54ad5defc6454f065c28af8b',
    SLIDER: '539adbd6dec7e10e686debee',
    GRID: '539ad60defb9600b94d7df2c',
    LIST: '5613c9cde69ddc09340c6beb',
    MINI: '53aa8912dec7e10d38f59f36',
    MICRO_REVIEW_COUNT: '5419b6ffb0d04a076446a9af',
    MICRO_TRUST_SCORE: '5419b637fa0340045cd0c936',
    MICRO_COMBO: '5419b6a8b0d04a076446a9ad',
    STARTER: '56278e9abfbbba0bdcd568bc',
    DROP_DOWN: '54d39695764ea907c0f34825',
    POP_UP: '56278e9abfbbba0bdcd568bc',
};

const TrustBox = ({ trustBoxRef, templateId, height, width, theme, stars }) => (
    <div
        ref={trustBoxRef}
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id={templateId}
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height={height}
        data-style-width={width}
        data-theme={theme}
        data-stars={stars}
    >
        <a
            href={REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            Trustpilot
        </a>
    </div>
);

class TrustBoxContainer extends Component {
    constructor(props) {
        super(props);
        this.trustBoxRef = React.createRef();
    }

    componentDidMount() {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    }

    render() {
        const {
            templateId = TRUSTPILOT_TEMPLATES.STARTER,
            height = '52px',
            width = '100%',
            theme = 'dark',
            stars = '4,5',
        } = this.props;

        return (
            <TrustBox
                trustBoxRef={this.trustBoxRef}
                templateId={templateId}
                height={height}
                width={width}
                theme={theme}
                stars={stars}
            />
        );
    }
}

export default TrustBoxContainer;
